const authorizationRequirements = [
  {
    id: 'YES',
    label: 'Required'
  },
  {
    id: 'NO',
    label: 'Explicitly not required'
  },
  {
    id: 'UNDISCLOSED',
    label: 'Unspecified'
  }
]


export default authorizationRequirements